import Tooltip from "../../Tooltip";

const Card = ({ card: { title, total, color, acronymKey } }) => {

  return (
    <div
      className="py-6 px-3 rounded-lg space-y-1 min-w-40 text-start w-full"
      style={{ backgroundColor: color }}
    >
     <p className="title-text-size text-[#2F4B7C]  break-words">
        {acronymKey ? <Tooltip id={acronymKey}>{title}</Tooltip> : title}
      </p>
      <p className=" text-xl 2xl:text-xl  font-medium"> {total}</p>
    </div>
  );
};

export default Card;
